import { __, __r } from 'react-i18n/lib';
import { Link } from 'react-router';
import {
  DsiCheckBox as CheckBox,
  DsiPasswordMeter as PasswordMeter,
  ErrorAlert,
  FlexColCenterVertical,
  FlexRow,
  FlexRowCenter,
  InfoText,
  DsiInfoText,
  DsiInfoType,
} from '../../..';
import { InfoType } from '../../Zemplin/General/InfoText';
import { FormInput, LoginButton, StyledLabel, Wrapper } from './LoginForm';
import { StyledLabel as PrivacyLabel } from '../Category/ProductFilterItem';
import { Loader } from '../../Zemplin/General/Loader';
import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  Form,
  Header,
  Required,
  StyledCheckBoxWrapper,
  StyledRegister,
} from './RegisterForm';
import { Select } from '../../Zemplin/General/Select';

interface Props {
  cartId: string | undefined;
  handleFormSubmit: any;
  isFetching: boolean;
  successMessage: string;
  errorMessage: string;
  lang: string;
}

function WarehouseRegisterForm({
  cartId,
  handleFormSubmit,
  isFetching,
  successMessage,
  errorMessage,
  lang,
}: Props) {
  const [email, setEmail] = React.useState('');
  const [telephone, setTelephone] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [isWarehouseSelected, setIsWarehouseSelected] = React.useState(false);
  const [isPrivacySelected, setIsPrivacySelected] = React.useState(false);
  const [isDsiAgreeSelected, setIsDsiAgreeSelected] = React.useState(false);
  const [isVatPayer, setIsVatPayer] = React.useState('1');
  const [country, setCountry] = React.useState('slovakia');
  const [deliveryCountry, setDeliveryCountry] = React.useState('slovakia');
  const form: any = React.useRef(null);
  const isB2BCheckbox: any = React.useRef(null);
  const isPrivacyCheckbox: any = React.useRef(null);
  const isDsiAgreeCheckbox: any = React.useRef(null);

  React.useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Enter' && form?.current) {
        (form?.current as any)?.requestSubmit();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const countries =
    lang === 'sk'
      ? [
          {
            name: 'Slovenská republika',
            value: 'slovakia',
          },
        ]
      : [
          {
            name: 'Česká republika',
            value: 'czech',
          },
        ];

  const changeWarehouseSelected = () => {
    setIsWarehouseSelected(!isWarehouseSelected);
  };

  const changePrivacySelected = () => {
    setIsPrivacySelected(!isPrivacySelected);
  };

  const changeDsiAgreeSelected = () => {
    setIsDsiAgreeSelected(!isDsiAgreeSelected);
  };

  const handleForm = e => {
    e.preventDefault();

    if (!isDsiAgreeSelected || !isPrivacySelected || !isWarehouseSelected) {
      if (!isWarehouseSelected) {
        window.alert(__('Pre registráciu musíte súhlasiť s prehlásením.'));
        if (isB2BCheckbox) {
          window.scrollTo({
            behavior: 'smooth',
            top: isB2BCheckbox.current.offsetTop,
          });
        }
      } else if (!isPrivacySelected) {
        window.alert(
          __('Pre registráciu musíte súhlasiť so spracovaním osobných údajov.'),
        );
        if (isPrivacyCheckbox) {
          window.scrollTo({
            behavior: 'smooth',
            top: isPrivacyCheckbox.current.offsetTop,
          });
        }
      } else if (!isDsiAgreeSelected) {
        window.alert(__('Pre registráciu musíte súhlasiť s podmienkami.'));
        if (isDsiAgreeCheckbox) {
          window.scrollTo({
            behavior: 'smooth',
            top: isDsiAgreeCheckbox.current.offsetTop,
          });
        }
      }
      return;
    }

    if (form) {
      const data = new FormData(form.current);

      const body: any = {};
      for (const [key, value] of data.entries()) {
        if (key === 'billing_address.country') {
          body.billing_address = {
            ...body.billing_address,
            country: {
              name: value,
              value: '',
            },
          };
        } else if (key === 'delivery_address.country') {
          body.delivery_address = {
            ...body.delivery_address,
            country: {
              name: value,
              value: '',
            },
          };
        } else if (key.includes('.')) {
          body[key.split('.')[0]] = {
            ...body[key.split('.')[0]],
            [key.split('.')[1]]: value,
          };
        } else {
          body[key] = value;
        }
      }
      handleFormSubmit(body);
    }
  };

  const changeVatPayer = () => {
    if (isVatPayer === '1') {
      setIsVatPayer('0');
    } else {
      setIsVatPayer('1');
    }
  };

  const changeCountry = () => {
    if (country === 'slovakia') {
      setCountry('czech');
    } else {
      setCountry('slovakia');
    }
  };

  const changeDeliveryCountry = () => {
    if (country === 'slovakia') {
      setDeliveryCountry('czech');
    } else {
      setDeliveryCountry('slovakia');
    }
  };

  return (
    <StyledWrapper>
      <Header>{`${__('Chcem sa stať veľkoobchodným partnerom')}`}</Header>
      {!successMessage ? (
        <>
          {successMessage && (
            <InfoText type={InfoType.SUCCESS} info={successMessage} />
          )}
          <form onSubmit={handleForm} ref={form}>
            <StyledCheckBoxWrapper ref={isB2BCheckbox}>
              <CheckBox
                name={'warehouse'}
                type={'checkbox'}
                selected={isWarehouseSelected}
                // tslint:disable-next-line:jsx-no-lambda
                onClick={changeWarehouseSelected}
              />
              <PrivacyLabel
                htmlFor={'warehouse'}
                selected={isWarehouseSelected}
              >
                {__(
                  `Prehlasujem, že sme obchodná spoločnosť alebo firma, ktorá nakupuje za účelom ďalšieho predaja. Náš predpokladaný nákup za rok bude presahovať minimálne 3,000 EUR.`,
                )}
              </PrivacyLabel>
            </StyledCheckBoxWrapper>
            <SubTitle>{`${__('Kontaktné údaje')}`}</SubTitle>
            <RowInput>
              <StyledInput marginRight={16}>
                <StyledLabel htmlFor="email">{`${__('Email')}`}</StyledLabel>
                <FormInput
                  type="email"
                  value={email}
                  placeholder={'@'}
                  name="email"
                  // tslint:disable-next-line:jsx-no-lambda
                  onChange={e => setEmail(e.target.value)}
                  tabIndex={1}
                  marginBottom={0}
                />
              </StyledInput>
              <StyledInput>
                <StyledLabel htmlFor="tel">
                  {`${__('Tel. číslo ')}`}
                </StyledLabel>
                <FormInput
                  type="tel"
                  value={telephone}
                  name="phone"
                  // tslint:disable-next-line:jsx-no-lambda
                  onChange={e => setTelephone(e.target.value)}
                  tabIndex={1}
                  marginBottom={0}
                />
              </StyledInput>
            </RowInput>
            <RowInput>
              <StyledInput marginRight={16} marginBottom={52}>
                <StyledLabel htmlFor="login">
                  {`${__('Login')}`}
                  <Required>{`*`}</Required>
                </StyledLabel>
                <FormInput
                  type="login"
                  name="login"
                  tabIndex={2}
                  marginBottom={0}
                />
              </StyledInput>
              {/* <StyledInput>
                <StyledLabel htmlFor="password">
                  {`${__('Heslo')}`}
                  <Required>{`*`}</Required>
                </StyledLabel>
                <FormInput
                  type="password"
                  value={password}
                  name="password"
                  // tslint:disable-next-line:jsx-no-lambda
                  onChange={e => setPassword(e.target.value)}
                  tabIndex={2}
                  marginBottom={0}
                />
                <PasswordMeter password={password} />
              </StyledInput> */}
            </RowInput>

            <SubTitle>{`${__('Fakturačná adresa')}`}</SubTitle>
            <StyledInput>
              <StyledLabel htmlFor="company.name">
                {`${__('Názov spoločnosti')}`}
                <Required>{`*`}</Required>
              </StyledLabel>
              <FormInput
                type="text"
                name="company.name"
                tabIndex={2}
                marginBottom={0}
              />
            </StyledInput>
            <StyledInput>
              <StyledLabel htmlFor="company.ico">
                {`${__('IČO')}`}
                <Required>{`*`}</Required>
              </StyledLabel>
              <FormInput
                type="text"
                name="company.ico"
                tabIndex={2}
                marginBottom={0}
              />
            </StyledInput>
            <StyledInput>
              <StyledLabel htmlFor="company.dic">
                {`${__('DIČ')}`}
                <Required>{`*`}</Required>
              </StyledLabel>
              <FormInput
                type="text"
                name="company.dic"
                tabIndex={2}
                marginBottom={0}
              />
            </StyledInput>
            <StyledInput>
              <StyledLabel htmlFor="company.vat_payer" marginBottom={8}>
                {`${__('Platca DPH')}`}
                <Required>{`*`}</Required>
              </StyledLabel>
              <Select
                value={isVatPayer}
                options={[
                  { name: __('Áno'), value: '1' },
                  { name: __('Nie'), value: '0' },
                ]}
                onChange={changeVatPayer}
                marginBottom={16}
                maxWidth={600}
                name="company.vat_payer"
              />
            </StyledInput>
            {lang === 'sk' ? (
              <StyledInput>
                <StyledLabel htmlFor="company.ic_dph">
                  {`${__('IČ DPH')}`}
                  <Required>{`*`}</Required>
                </StyledLabel>
                <FormInput
                  type="text"
                  tabIndex={2}
                  marginBottom={0}
                  name="company.ic_dph"
                />
              </StyledInput>
            ) : (
              <></>
            )}
            <RowInput>
              <StyledInput marginRight={16}>
                <StyledLabel htmlFor="billing_address.name">
                  {`${__('Meno')}`}
                  <Required>{`*`}</Required>
                </StyledLabel>
                <FormInput
                  type="text"
                  name="billing_address.name"
                  tabIndex={2}
                  marginBottom={0}
                />
              </StyledInput>
              <StyledInput>
                <StyledLabel htmlFor="billing_address.surname">
                  {`${__('Priezvisko')}`}
                  <Required>{`*`}</Required>
                </StyledLabel>
                <FormInput
                  type="text"
                  name="billing_address.surname"
                  tabIndex={2}
                  marginBottom={0}
                />
              </StyledInput>
            </RowInput>
            <RowInput>
              <StyledFlexRow>
                <StyledInput marginRight={16} mobileMarginRight={16}>
                  <StyledLabel htmlFor="billing_address.street">
                    {`${__('Ulica')}`}
                    <Required>{`*`}</Required>
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="billing_address.street"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </StyledInput>
                <NumberInput marginRight={16}>
                  <StyledLabel htmlFor="billing_address.number">
                    {`${__('Číslo')}`}
                    <Required>{`*`}</Required>
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="billing_address.number"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </NumberInput>
              </StyledFlexRow>
              <StyledFlexRow>
                <StyledInput marginRight={16} mobileMarginRight={16}>
                  <StyledLabel htmlFor="billing_address.city">
                    {`${__('Mesto')}`}
                    <Required>{`*`}</Required>
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="billing_address.city"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </StyledInput>
                <NumberInput>
                  <StyledLabel htmlFor="billing_address.zip">
                    {`${__('PSČ')}`}
                    <Required>{`*`}</Required>
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="billing_address.zip"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </NumberInput>
              </StyledFlexRow>
            </RowInput>
            <StyledInput>
              <StyledLabel htmlFor="billing_address.country" marginBottom={8}>
                {`${__('Krajina')}`}
                <Required>{`*`}</Required>
              </StyledLabel>
              <Select
                value={country}
                options={countries}
                onChange={changeCountry}
                marginBottom={16}
                maxWidth={600}
                name="billing_address.country"
              />
            </StyledInput>

            <SubTitle>{`${__('Údaje o prevádzke')}`}</SubTitle>
            <RowInput>
              <StyledInput marginRight={16}>
                <StyledLabel htmlFor="delivery_address.company_name">
                  {`${__('Názov prevádzky')}`}
                </StyledLabel>
                <FormInput
                  type="text"
                  name="delivery_address.company_name"
                  tabIndex={1}
                  marginBottom={0}
                />
              </StyledInput>
            </RowInput>
            <RowInput>
              <StyledFlexRow>
                <StyledInput marginRight={16} mobileMarginRight={16}>
                  <StyledLabel htmlFor="delivery_address.street">
                    {`${__('Dodanie ulica')}`}
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="delivery_address.street"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </StyledInput>
                <NumberInput marginRight={16}>
                  <StyledLabel htmlFor="delivery_address.number">
                    {`${__('Číslo')}`}
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="delivery_address.number"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </NumberInput>
              </StyledFlexRow>
              <StyledFlexRow>
                <StyledInput marginRight={16} mobileMarginRight={16}>
                  <StyledLabel htmlFor="delivery_address.city">
                    {`${__('Dodanie obec')}`}
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="delivery_address.city"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </StyledInput>
                <NumberInput>
                  <StyledLabel htmlFor="delivery_address.zip">
                    {`${__('PSČ')}`}
                  </StyledLabel>
                  <FormInput
                    type="text"
                    name="delivery_address.zip"
                    tabIndex={2}
                    marginBottom={0}
                  />
                </NumberInput>
              </StyledFlexRow>
            </RowInput>
            <StyledInput>
              <StyledLabel htmlFor="delivery_address.country" marginBottom={8}>
                {`${__('Dodanie krajina')}`}
              </StyledLabel>
              <Select
                value={deliveryCountry}
                options={countries}
                onChange={changeDeliveryCountry}
                marginBottom={16}
                maxWidth={600}
                name="delivery_address.country"
              />
            </StyledInput>

            <SubTitle>{`${__('Bankové spojenie')}`}</SubTitle>
            <RowInput>
              <StyledInput marginRight={16}>
                <StyledLabel htmlFor="bank_name">
                  {`${__('Názov banky')}`}
                  <Required>{`*`}</Required>
                </StyledLabel>
                <FormInput
                  type="text"
                  name="bank_name"
                  tabIndex={1}
                  marginBottom={0}
                />
              </StyledInput>
              <StyledInput>
                <StyledLabel htmlFor="iban">
                  {`${__('Číslo účtu vo formáte IBAN')}`}
                  <Required>{`*`}</Required>
                </StyledLabel>
                <FormInput
                  type="text"
                  name="iban"
                  tabIndex={1}
                  marginBottom={0}
                />
              </StyledInput>
            </RowInput>
            <SubTitle>{`${__('Doplňujúce informácie')}`}</SubTitle>
            <RowInput>
              <StyledInput marginRight={16}>
                <StyledLabel htmlFor="bussiness_desc">
                  {`${__('Popis podnikateľskej činnosti')}`}
                </StyledLabel>
                <FormInput
                  type="text"
                  name="bussiness_desc"
                  placeholder={__('Napr. elektropredajca')}
                  tabIndex={1}
                  marginBottom={0}
                />
              </StyledInput>
              <StyledInput>
                <StyledLabel htmlFor="web">{`${__('Web')}`}</StyledLabel>
                <FormInput
                  type="text"
                  name="web"
                  tabIndex={1}
                  marginBottom={0}
                />
              </StyledInput>
            </RowInput>

            <StyledInput>
              <StyledLabel htmlFor="web">{`${__('Poznámka')}`}</StyledLabel>
              <FormInput
                type="text"
                name="note"
                tabIndex={1}
                marginBottom={0}
              />
            </StyledInput>

            <StyledCheckBoxWrapper ref={isPrivacyCheckbox}>
              <CheckBox
                name={'privacy'}
                type={'checkbox'}
                selected={isPrivacySelected}
                onClick={changePrivacySelected}
              />
              <PrivacyLabel htmlFor={'privacy'} selected={isPrivacySelected}>
                {__(`Súhlasím so spracovaním`)}
                <Link
                  to={__r(
                    'routes:spracovanie-osobnych-udajov',
                    '/spracovanie-osobnych-udajov',
                  )}
                >
                  <StyledRegister selected={isPrivacySelected}>
                    {__(`osobných údajov`)}
                  </StyledRegister>
                </Link>
              </PrivacyLabel>
            </StyledCheckBoxWrapper>
            <StyledCheckBoxWrapper ref={isDsiAgreeCheckbox}>
              <CheckBox
                name={'dsiAgree'}
                type={'checkbox'}
                selected={isDsiAgreeSelected}
                // tslint:disable-next-line:jsx-no-lambda
                onClick={changeDsiAgreeSelected}
              />
              <PrivacyLabel htmlFor={'dsiAgree'} selected={isDsiAgreeSelected}>
                {__(
                  `Súhlasím s tým, že poskytnutím týchto údajov nám nevzniká automaticky nárok na získanie podmienok k veľkoobchodnej spolupráci a rozhodnutie je v plnej kompetencii DSI Slovakia s.r.o.`,
                )}
              </PrivacyLabel>
            </StyledCheckBoxWrapper>

            {errorMessage ? (
              <DsiInfoText
                marginBottom={0}
                marginTop={12}
                type={DsiInfoType.ERROR}
                info={__(errorMessage)}
              />
            ) : (
              <></>
            )}

            <StyledLoginButton type="submit">
              {isFetching ? (
                <FlexRowCenter>
                  {`${__('Registrujem')}...`}
                  <Loader className="marginLeft" small={true} />
                </FlexRowCenter>
              ) : (
                __('Odoslať žiadosť')
              )}
            </StyledLoginButton>
            {errorMessage ? (
              <InfoWrapper>
                <InfoText
                  type={InfoType.ERROR}
                  info={
                    <>
                      <span>{errorMessage}</span>{' '}
                    </>
                  }
                />
              </InfoWrapper>
            ) : null}
          </form>
        </>
      ) : (
        <InfoWrapper>
          <InfoText
            type={InfoType.SUCCESS}
            info={
              <>
                <span>{__('Žiadosť o registráciu bola zaznamenaná.')}</span>{' '}
              </>
            }
          />
        </InfoWrapper>
      )}
    </StyledWrapper>
  );
}

const InfoWrapper = styled.div`
  margin-top: ${rem(24)};
`;

const StyledWrapper = styled(Wrapper)`
  max-width: ${rem(753)};
`;

const StyledLoginButton = styled(LoginButton)`
  max-width: ${rem(753)};
  margin-bottom: 0;
`;

const SubTitle = styled.h2`
  font-size: ${rem(30)};
  font-weight: 400;
  margin-top: ${rem(56)};
`;

export const RowInput = styled(FlexRow)<{
  maxWidth?: number;
  marginBottom: number;
  isB2B?: boolean;
}>`
  max-width: ${({ maxWidth }) => (maxWidth ? rem(maxWidth) : 'initial')};
  flex-flow: ${({ isB2B }) => (isB2B ? 'column' : 'row')};
  margin-bottom: ${({ marginBottom, isB2B }) =>
    isB2B ? 0 : marginBottom ? rem(marginBottom) : 0};
  ${({ theme }) => theme.mediab.m600`
        flex-direction: column;
    `}
`;

export const StyledInput = styled(FlexColCenterVertical)<{
  marginRight: number;
  marginBottom?: number;
}>`
  width: 100%;
  max-width: ${rem(345)};
  margin-right: ${({ marginRight }) => (marginRight ? rem(marginRight) : 0)};
  ${({ theme }) => theme.mediab.m600`
        max-width: ${rem(600)};
        margin-right: ${({ mobileMarginRight }) =>
          mobileMarginRight ? rem(mobileMarginRight) : 0}
    `};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : rem(16)};
`;

export const NumberInput = styled(StyledInput)<{ isB2B?: boolean }>`
  max-width: ${({ isB2B }) => (isB2B ? rem(345) : rem(80))};
  ${({ theme }) => theme.mediab.m600`
        max-width: ${rem(80)};
    `}
`;

export const StyledFlexRow = styled(FlexRow)<{ isB2B?: boolean }>`
  width: 100%;
  flex-flow: ${({ isB2B }) => (isB2B ? 'column' : 'row')};
`;

export { WarehouseRegisterForm as DsiWarehouseRegisterForm };
